import { JSX } from 'react';
import { TabBar } from '@greystar/designsystem';
import type { FeeTab } from '../../component-props';

// Props for Tabs component
export type TabBarProps = {
  tabList: FeeTab[];
  activeTabId: string;
  onTabClick: (tabId: string) => void;
  backgroundColour?: 'white' | 'beige' | 'sky';
  prevLabel?: string;
  nextLabel?: string;
};

const Tabs = ({
  tabList,
  activeTabId,
  onTabClick,
  backgroundColour,
  prevLabel,
  nextLabel,
}: TabBarProps): JSX.Element | null => {
  if (!activeTabId) return null;

  const tabItems = tabList?.map((item: FeeTab) => ({
    id: item.fields.tabId.value,
    title: item.fields.tabTitle.value,
  }));

  return (
    <div
      id="tabs"
      data-testid="tabs"
      className="[&_.tab-bar-wrapper]:pt-0 [&_.tab-bar-wrapper]:pb-2"
    >
      <TabBar
        activeTabId={activeTabId}
        tabItems={tabItems}
        onClick={onTabClick}
        backgroundColour={backgroundColour}
        prevLabel={prevLabel}
        nextLabel={nextLabel}
      />
    </div>
  );
};

export default Tabs;
